export default RegExp("^[a-z0-9_\\-\\.]{1,64}@[a-z0-9\\-\\.]{1,255}\\.[a-z0-9]{2,30}$");